import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
// eslint-disable-next-line no-unused-vars
import {
  UserProfileTypes,
  UserProfileInterface,
  UserProfileRequestInterface,
  UserProfileListAvailableInterface,
  DocumentsListInterface,
  UserProfileRequestAttachment,
  userProfileListImportsDataInterface,
} from './types';

// List UseProfile
export const listUserProfileRequest = (payload: object) =>
  action(UserProfileTypes.LIST_USERPROFILE_REQUEST, payload);

export const listUserProfileSuccess = (payload: {
  userProfileList: UserProfileInterface[];
}) => action(UserProfileTypes.LIST_USERPROFILE_REQUESTS_REQUEST, payload);

export const listUserProfileFailure = () =>
  action(UserProfileTypes.LIST_USERPROFILE_FAILURE);

// List UseProfile Request
export const listUserProfileRequestsRequest = (payload: object) =>
  action(UserProfileTypes.LIST_USERPROFILE_REQUESTS_REQUEST, payload);

export const listUserProfileRequestsSuccess = (payload: {
  userProfileListRequest: UserProfileRequestInterface[];
  totalCount: number;
}) => action(UserProfileTypes.LIST_USERPROFILE_REQUESTS_SUCCESS, payload);

export const listUserProfileRequestsFailure = () =>
  action(UserProfileTypes.LIST_USERPROFILE_REQUESTS_FAILURE);

// List UseProfile Available
export const listUserProfileAvailableRequest = (payload: object) =>
  action(UserProfileTypes.LIST_USERPROFILE_AVAILABLE_REQUEST, payload);

export const listUserProfileAvailableSuccess = (payload: {
  userProfileListAvailable: UserProfileListAvailableInterface[];
}) => action(UserProfileTypes.LIST_USERPROFILE_AVAILABLE_SUCCESS, payload);

export const listUserProfileAvailableFailure = () =>
  action(UserProfileTypes.LIST_USERPROFILE_AVAILABLE_FAILURE);

// Update UseProfile
export const updateUserProfileRequest = (payload: object) =>
  action(UserProfileTypes.UPDATE_USERPROFILE_REQUEST, payload);
export const updateUserProfileSuccess = (payload: {
  userProfileData: UserProfileInterface;
}) => action(UserProfileTypes.UPDATE_USERPROFILE_SUCCESS, payload);
export const updateUserProfileFailure = () =>
  action(UserProfileTypes.UPDATE_USERPROFILE_FAILURE);

// Update UseProfile Status
export const updateUserProfileStatusRequest = (payload: object) =>
  action(UserProfileTypes.UPDATE_USERPROFILE_STATUS_REQUEST, payload);

export const updateUserProfileStatusSuccess = (payload: {
  userProfileData: UserProfileInterface;
}) => action(UserProfileTypes.UPDATE_USERPROFILE_STATUS_SUCCESS, payload);

export const updateUserProfileStatusFailure = () =>
  action(UserProfileTypes.UPDATE_USERPROFILE_STATUS_FAILURE);

// Update UseProfile Requests
export const updateUserProfileRequestsRequest = (payload: object) =>
  action(UserProfileTypes.UPDATE_USERPROFILE_REQUESTS_REQUEST, payload);

export const updateUserProfileRequestsSuccess = (payload: {
  userProfileData: UserProfileInterface;
}) => action(UserProfileTypes.UPDATE_USERPROFILE_REQUESTS_SUCCESS, payload);

export const updateUserProfileRequestsFailure = () =>
  action(UserProfileTypes.UPDATE_USERPROFILE_REQUESTS_FAILURE);

// Update UseProfile Expiration
export const updateUserProfileExpirationRequest = (payload: object) =>
  action(UserProfileTypes.REQUEST_USERPROFILE_EXPIRATION_REQUEST, payload);

export const updateUserProfileExpirationSuccess = () =>
  action(UserProfileTypes.REQUEST_USERPROFILE_EXPIRATION_SUCCESS);

export const updateUserProfileExpirationFailure = () =>
  action(UserProfileTypes.REQUEST_USERPROFILE_EXPIRATION_FAILURE);

// Create UseProfile
export const requestUserProfileRequest = (payload: object) =>
  action(UserProfileTypes.REQUEST_USERPROFILE_REQUEST, payload);
export const requestUserProfileSuccess = (payload: {
  userProfileData: UserProfileInterface;
}) => action(UserProfileTypes.REQUEST_USERPROFILE_SUCCESS, payload);
export const requestUserProfileFailure = () =>
  action(UserProfileTypes.REQUEST_USERPROFILE_FAILURE);

// Update UseProfile
export const updateUserProfileDataRequest = (payload: object) =>
  action(UserProfileTypes.UPDATE_USERPROFILE_DATA_REQUEST, payload);
export const updateUserProfileDataSuccess = (payload: {
  userProfileData: UserProfileInterface;
}) => action(UserProfileTypes.UPDATE_USERPROFILE_DATA_SUCCESS, payload);
export const updateUserProfileDataFailure = () =>
  action(UserProfileTypes.UPDATE_USERPROFILE_DATA_FAILURE);

// Request UseProfile Attachment
export const requestUserProfileAttachmentRequest = (payload: object) =>
  action(UserProfileTypes.REQUEST_USERPROFILE_ATTACHMENT_REQUEST, payload);
export const requestUserProfileAttachmentSuccess = (payload: {
  userProfileAttachmentList: UserProfileRequestAttachment;
}) => action(UserProfileTypes.REQUEST_USERPROFILE_ATTACHMENT_SUCCESS, payload);
export const requestUserProfileAttachmentFailure = () =>
  action(UserProfileTypes.REQUEST_USERPROFILE_ATTACHMENT_FAILURE);

// Documents List
export const documentsList = (payload: {
  documentsList: DocumentsListInterface[];
}) => action(UserProfileTypes.DOCUMENTS_LIST, payload);

// Current Card
export const currentCard = (payload: { cardIndex: number }) =>
  action(UserProfileTypes.CURRENT_CARD, payload);

// Create Chips
export const chipsList = (payload: { chipsList: any }) =>
  action(UserProfileTypes.CREATE_CHIPS_LIST, payload);

// Clean Chips
export const cleanChipsList = () => action(UserProfileTypes.CLEAN_CHIPS_LIST);

// user Profile Import
export const userProfileImportRequest = (payload: {
  attachment: File[];
  importType: string;
  fileName: string;
}) => asyncAction(UserProfileTypes.USER_PROFILE_IMPORT_REQUEST, payload);
export const userProfileImportSuccess = () =>
  action(UserProfileTypes.USER_PROFILE_IMPORT_SUCCESS);
export const userProfileImportFailure = () =>
  action(UserProfileTypes.USER_PROFILE_IMPORT_FAILURE);

// Manual Release
export const userProfileManualReleaseRequest = (payload: object) =>
  action(UserProfileTypes.USER_PROFILE_MANUAL_RELEASE_REQUEST, payload);
export const userProfileManualReleaseSuccess = (payload: {
  userProfileData: UserProfileInterface;
}) => action(UserProfileTypes.USER_PROFILE_MANUAL_RELEASE_SUCCESS, payload);
export const userProfileManualReleaseFailure = () =>
  action(UserProfileTypes.USER_PROFILE_MANUAL_RELEASE_FAILURE);

// Renew Payment
export const userProfileRenewPaymentRequest = (payload: { userProfileId: string }) =>
  action(UserProfileTypes.USER_PROFILE_RENEW_PAYMENT_REQUEST, payload);
export const userProfileRenewPaymentSuccess = (payload: {
  renewalPaymentData: import('./types').RenewalPaymentData;
}) => action(UserProfileTypes.USER_PROFILE_RENEW_PAYMENT_SUCCESS, payload);
export const userProfileRenewPaymentFailure = () =>
  action(UserProfileTypes.USER_PROFILE_RENEW_PAYMENT_FAILURE);
export const userProfileRenewPaymentReset = () =>
  action(UserProfileTypes.USER_PROFILE_RENEW_PAYMENT_RESET);

// user Profile Import
export const userProfileListImportsRequest = (payload: Object) =>
  action(UserProfileTypes.USER_PROFILE_LIST_IMPORTS_REQUEST, payload);
export const userProfileListImportsSuccess = (payload: {
  userProfileListImportsData: userProfileListImportsDataInterface[];
}) => action(UserProfileTypes.USER_PROFILE_LIST_IMPORTS_SUCCESS, payload);
export const userProfileListImportsFailure = () =>
  action(UserProfileTypes.USER_PROFILE_LIST_IMPORTS_FAILURE);
